import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const mail = new Restful(project, 'mail')

mail.history = function(data) {
  const url = project + 'mail/history'
  return http.get(url, data).then(res => {
    return res
  })
}

const mailAddress = new Restful(project, 'mail/address')

mailAddress.getNum = function(data) {
  const url = project + 'mail/address/num'
  return http.get(url, data).then(res => {
    return res
  })
}

mailAddress.getList = function(data) {
  const { type, ...params } = data
  const url = project + 'mail/address/' + type
  return http.get(url, params).then(res => {
    return res
  })
}

mailAddress.getQuery = function(type, id, data) {
  const url = project + `mail/address/${type}/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

mailAddress.addQuery = function(type, data) {
  const url = project + `mail/address/${type}`
  return http.post(url, data).then(res => {
    return res
  })
}

mailAddress.editQuery = function(type, id, data) {
  const url = project + `mail/address/${type}/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

mailAddress.delQuery = function(type, id, data) {
  const url = project + `mail/address/${type}/${id}`
  return http.del(url, data).then(res => {
    return res
  })
}

const mailTemplate = new Restful(project, 'mail/template')

const mailFrom = new Restful(project, 'mail/from')

const mailVariable = new Restful(project, 'mail/variable')

const mailLetterFamily = new Restful(project, 'mail/letter/family')

const mailSignature = new Restful(project, 'mail/signature')

const mailRecord = new Restful(project, 'mail/record')

const mailEvent = new Restful(project, 'mail/event')

mailEvent.event = function(event, data) {
  const url = project + 'mail/event/template/' + event
  return http.get(url, data).then(res => {
    return res
  })
}

mailEvent.associated = function(event, data) {
  const url = project + 'mail/event/template/list/' + event
  return http.post(url, data).then(res => {
    return res
  })
}

mailEvent.associatedList = function(event, data) {
  const url = project + 'mail/event/template/' + event
  return http.post(url, data).then(res => {
    return res
  })
}
const mailAction = new Restful(project, 'mail/action')

mailAction.template = function(event, data) {
  const url = project + 'mail/action/' + event + '/template'
  return http.get(url, data).then(res => {
    return res
  })
}

mailAction.templateQuery = function(event, data) {
  const url = project + 'mail/action/template/' + event
  return http.get(url, data).then(res => {
    return res
  })
}

mailAction.send = function(data) {
  const url = project + 'mail/action/send'
  return http.post(url, data).then(res => {
    return res
  })
}

const mailManuscript = new Restful(project, 'mail/event')

mailManuscript.record = function(id, data) {
  const url = project + 'mail/manuscript/' + id + '/record'
  return http.get(url, data).then(res => {
    return res
  })
}

const mailReport = new Restful(project, 'mail_record')

export default mail
export {
  mail,
  mailTemplate,
  mailFrom,
  mailVariable,
  mailLetterFamily,
  mailAddress,
  mailSignature,
  mailEvent,
  mailAction,
  mailRecord,
  mailManuscript,
  mailReport
}
